import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import SelectMultipleItemsComponent from "../widgets/selectMultipleItemsComponent/SelectMultipleItemsComponent";
import { useStoreState } from 'easy-peasy';
import { useSearchParams } from "react-router-dom";
import HelperMetiers360 from "../../services/HelpersMetiers360";

const ApkFiltersComponent = ({ allApks, setFilteredApks, search, loaderApps }) => {

    const { apiData: { BACKOFFICE_DEFAULT_VALUES } } = useStoreState(state => state.actionSlugs);
    const { typeOfHeadset: allHeadsetsTypes } = BACKOFFICE_DEFAULT_VALUES;
    const [searchParam, setSearchParam] = useSearchParams();

    const [allApps, setAllApps] = useState(allApks);

    const [kioskMode, setKioskMode] = useState(searchParam.get("kioskMode") || "all");
    const [deviceTypes, setDeviceTypes] = useState(allHeadsetsTypes?.filter(ht => searchParam.get("deviceTypes")?.split(",")?.includes(ht.name)));
    const [loaderMin, setLoaderMin] = useState(searchParam.get("loaderMin") || "");
    const [deviceTypeExclusive, setDeviceTypeExclusive] = useState(JSON.parse(searchParam.get("deviceTypeExclusive") || "false"));
    const [loaderVersionExclusive, setLoaderVersionExclusive] = useState(JSON.parse(searchParam.get("loaderVersionExclusive") || "false"));

    const setParamsToUrl = (newParams = {}) => {
        const currentParams = Object.fromEntries(searchParam.entries());
        const updatedParams = { ...currentParams, ...newParams };
        setSearchParam(updatedParams);
    };

    const resetFilters = () => {
        setKioskMode('all');
        setDeviceTypes([]);
        setLoaderMin("");
        setDeviceTypeExclusive(false);
        setLoaderVersionExclusive(false);
    }

    useEffect(() => {
        if (loaderApps) {
            resetFilters();
            const appsToDisplay = allApks?.filter(app => loaderApps?.some(lapp => lapp.appPackage?.url?.split("/").pop() == app.appPackage));
            setAllApps(appsToDisplay);
        } else {
            setAllApps(allApks);
        }
    }, [loaderApps]);

    useEffect(() => {
        setParamsToUrl({
            loaderMin: loaderMin || "",
            deviceTypes: deviceTypes?.length ? deviceTypes.map(dt => dt.name).join(",") : "",
            deviceTypeExclusive,
            kioskMode: kioskMode || "",
            loaderVersionExclusive
        });
    }, [loaderMin, deviceTypes, deviceTypeExclusive, kioskMode, loaderVersionExclusive]);

    const matchesDeviceFilter = (app) => {
        if (!deviceTypes.length) return true;

        const selectedNames = deviceTypes.map(dt => dt.name);
        const wantsNoType = deviceTypes.some(dt => dt.reference === 0);
        const appTypes = app.typeNames || [];
        const appHasNoType = appTypes.length === 0;
        const matchedTypes = appTypes.filter(tn => selectedNames.includes(tn));

        if (!deviceTypeExclusive) {
            return matchedTypes.length > 0 || (wantsNoType && appHasNoType);
        }

        if (selectedNames.length === 1 && wantsNoType) {
            return appHasNoType;
        }

        if (selectedNames.length !== appTypes.length) return false;

        const sortedSelected = [...selectedNames].sort();
        const sortedApp = [...appTypes].sort();

        return sortedSelected.every((name, i) => name === sortedApp[i]);
    };

    const onFilterChange = () => {
        const appsToDisplay = allApps?.filter((app) =>
            (!loaderMin ||
                ((app.loaderConditions.some(loaderCondition => (loaderVersionExclusive && parseInt(loaderCondition.loaderMinVersion) == loaderMin) || (!loaderVersionExclusive && parseInt(loaderCondition.loaderMinVersion) <= loaderMin)))
                ))
            && (kioskMode == 'all' || (kioskMode == 'kiosk' && !!app.isKioskMode) || (kioskMode == 'noKiosk' && !app.isKioskMode))
            && matchesDeviceFilter(app))
            .filter(app =>
                HelperMetiers360.isSearchInText(search, app.apkVersion)
                || HelperMetiers360.isSearchInText(search, app.originalName)
                || HelperMetiers360.isSearchInText(search, app.description)
        );
        setFilteredApks(appsToDisplay)
    }

    useEffect(() => {
        onFilterChange();
    }, [kioskMode, deviceTypes, search, loaderMin, deviceTypeExclusive, allApps, loaderVersionExclusive]);

    return (
        <Row className={"d-flex align-items-center pe-0"}>
            <Col className="m360-col3-start">
                <label className="label-select">Type&nbsp;de&nbsp;casques&nbsp;:</label>
                <span className="d-flex flex-column w-100">
                    <SelectMultipleItemsComponent itemsSelected={deviceTypes} setItemsSelected={setDeviceTypes}
                        items={allHeadsetsTypes} name="deviceType" itemKey="reference" itemValue="name" id='select-deviceType'
                        labelNone="type de casque" />
                    {deviceTypes.length > 0 &&
                        <Form.Check
                        id="device-exclusive"
                            checked={deviceTypeExclusive}
                            onChange={(e) => setDeviceTypeExclusive(e.target.checked)}
                            label="Exclusif"
                        />
                    }
                </span>
            </Col>
            <Col className="m360-col3-center">
                <span className="d-flex flex-column align-items-center w-100">
                    <div>
                        <label className="label-select" htmlFor="minLoaderVersion">Version Loader min : </label>
                        <input type="number" name="minLoaderVersion" value={loaderMin} min="0" onChange={(e) => setLoaderMin(e.target.value)} />
                        {loaderMin &&
                            <Form.Check
                                id="loader-exclusive"
                                checked={loaderVersionExclusive}
                                onChange={(e) => setLoaderVersionExclusive(e.target.checked)}
                                label="Exclusif"
                            />
                        }
                    </div>
                </span>
            </Col>
            <Col className="m360-col3-end">
                <label className="label-select">Mode Kiosk : </label>
                <div className='choices-selector-inline'>
                    <div className={kioskMode === 'kiosk' ? 'selected' : null}
                        onClick={() => setKioskMode('kiosk')} onKeyDown={() => setKioskMode('kiosk')}>
                        Oui</div>
                    <div className={kioskMode === 'all' ? 'selected' : null}
                        onClick={() => setKioskMode('all')} onKeyDown={() => setKioskMode('all')}>
                        Tous</div>
                    <div className={kioskMode === 'noKiosk' ? 'selected' : null}
                        onClick={() => setKioskMode('noKiosk')} onKeyDown={() => setKioskMode('noKiosk')}>
                        Non</div>
                </div>
            </Col>
        </Row>
    )
}

export default ApkFiltersComponent